export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11879.8ab277ba.jpg";